import React from 'react';

export function KeyboardArrowDownIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M14.82 17.18L24 26.34l9.18-9.16L36 20 24 32 12 20l2.82-2.82z" />
    </svg>
  );
}
